// extracted by mini-css-extract-plugin
export default {"containerVerticalStepper":"stepper-styles_containerVerticalStepper__7aOkd","verticalStepperSxElement":"stepper-styles_verticalStepperSxElement__Y2iHL"};